import * as React from 'react';
import { css } from '@emotion/react';
import { useRouter } from 'next/router';
import { useMutation, useQuery } from '@apollo/client';
import { DesignSystemProvider } from '@zapier/design-system';
import { UniversalLayout } from '@zapier/universal-layout';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import { NotificationProvider } from '@zapier/auth-pages';

import { Link } from './Link';

type Props = {
  children: React.ReactNode;
};

const rootStyle = css`
  box-sizing: border-box;
  min-height: 100%;
  display: grid;
  position: relative;
`;

export function PageLayout(props: Props) {
  const { trackEvent } = useTrackingContext();
  const router = useRouter();

  return (
    <DesignSystemProvider LinkComponent={Link}>
      <NotificationProvider notificationTimeout={30000}>
        <UniversalLayout
          currentUrl={router.asPath}
          trackEvent={trackEvent}
          // We do not want to render alerts on these pages
          renderAlertBanner={() => null}
          // We do not want to render a footer on these pages
          renderFooter={() => null}
          // @ts-ignore
          useMutation={useMutation}
          // @ts-ignore
          useQuery={useQuery}
        >
          <div css={rootStyle}>{props.children}</div>
        </UniversalLayout>
      </NotificationProvider>
    </DesignSystemProvider>
  );
}
